import queryAppointmentScheduler from './queryAppointmentScheduler';
import queryBannerData from './queryBannerData';
import queryBlogEmailCapture from './queryBlogEmailCapture';
import queryCarrierFilters from './queryCarrierFilters';
import queryCustomerCenter from './queryCustomerCenter';
import queryHideHelpMeSection from './queryHideHelpMeSection';
import queryHideMedicareGuideSticky from './queryHideMedicareGuideSticky';
import queryMedicareTools from './queryMedicareTools';
import queryPhoneInMSArticle from './queryPhoneInMSArticle';
import queryProvidenceCompliance from './queryProvidenceCompliance';
import querySearch from './querySeach';
import querySepBannerData from './querySepBannerData';
import queryZipModal from './queryZipModal';

// in gatsby it's impossible to write more than one static query in a file.
// so if we wrote these queries directly in components,
// that would prevent those components from making any other static queries.
// by importing them in a reusable hook, they don't "count" as a static query for that file.
// as seen below, importing multiple queries into one file is fine for some reason.

export default () => {
    return {
        AppointmentScheduler: queryAppointmentScheduler,
        BannerData: queryBannerData,
        BlogEmailCapture: queryBlogEmailCapture,
        CarrierFilters: queryCarrierFilters,
        CustomerCenter: queryCustomerCenter,
        HideHelpMeSection: queryHideHelpMeSection,
        HideMedicareGuideSticky: queryHideMedicareGuideSticky,
        MedicareTools: queryMedicareTools,
        ProvidenceCompliance: queryProvidenceCompliance,
        Search: querySearch,
        SepBannerData: querySepBannerData,
        ShowPhoneInMSArticle: queryPhoneInMSArticle,
        ZipModal: queryZipModal,
    };
};
